"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SelectItemsMobile = _interopRequireDefault(require("./SelectItemsMobile.proptypes"));

var _excluded = ["items", "placeholder", "showPicker", "onValueChange", "onClick", "onBlur", "label", "value", "enablePaxAgeUpdate"];

var Select = _styledComponents.default.select.withConfig({
  displayName: "SelectItemsMobile__Select",
  componentId: "sc-1bl2fl7-0"
})(["width:", ";position:absolute;top:", ";left:", ";border:none;background:transparent;color:", ";opacity:0;font-weight:", ";font-size:", ";padding:0;outline:none;line-height:", ";-moz-appearance:none;-webkit-appearance:none;appearance:none;"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyDark;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.normal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.normal;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight.XLarge;
});

Select.displayName = 'Select';

var Option = _styledComponents.default.option.withConfig({
  displayName: "SelectItemsMobile__Option",
  componentId: "sc-1bl2fl7-1"
})(["color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.default;
});

Option.displayName = 'Option';

var getSelected = function getSelected(selectedValue, items) {
  return items.find(function (_ref9) {
    var value = _ref9.value;
    return value.toString() === selectedValue;
  });
};

var SelectItemsMobile = function SelectItemsMobile(_ref10) {
  var items = _ref10.items,
      placeholder = _ref10.placeholder,
      showPicker = _ref10.showPicker,
      onValueChange = _ref10.onValueChange,
      onClick = _ref10.onClick,
      onBlur = _ref10.onBlur,
      label = _ref10.label,
      value = _ref10.value,
      enablePaxAgeUpdate = _ref10.enablePaxAgeUpdate,
      restProps = (0, _objectWithoutProperties2.default)(_ref10, _excluded);
  var childAgeList = items && (items === null || items === void 0 ? void 0 : items.length) && (items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.label) <= 11;
  }));
  var ageList = enablePaxAgeUpdate ? childAgeList : items;

  var handleValueChange = function handleValueChange(event) {
    var selectedValue = event.target.value;

    if (!selectedValue) {
      onValueChange(null, -1);
    }

    var selected = getSelected(selectedValue, items);
    var selectedIndex = items.indexOf(selected);
    onValueChange(selected, selectedIndex);
  };

  return /*#__PURE__*/_react.default.createElement(Select, (0, _extends2.default)({}, restProps, {
    value: value,
    onChange: handleValueChange,
    onClick: onClick,
    onBlur: onBlur
  }), ageList === null || ageList === void 0 ? void 0 : ageList.map(function (_ref11) {
    var itemLabel = _ref11.label,
        itemValue = _ref11.value;
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: itemValue,
      label: itemLabel,
      key: itemLabel
    }, itemLabel);
  }));
};

SelectItemsMobile.propTypes = _SelectItemsMobile.default.PropTypes;
SelectItemsMobile.defaultProps = _SelectItemsMobile.default.DefaultProps;
var _default = SelectItemsMobile;
exports.default = _default;